module.exports = __webpack_public_path__ + "static/media/waitlist-member-6.28173988.jpeg";